"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HotelRewardsFormActions;
(function (HotelRewardsFormActions) {
    HotelRewardsFormActions["HotelsLoaded"] = "HotelsLoaded";
})(HotelRewardsFormActions || (HotelRewardsFormActions = {}));
exports.default = HotelRewardsFormActions;
